const API_URL = process.env.REACT_APP_API_URL || '';

/** Backend origin without trailing `/api` (for uploads and static files). */
export function getBackendOrigin() {
  if (!API_URL) return '';
  return API_URL.replace(/\/api\/?$/i, '').replace(/\/$/, '');
}

/**
 * Build a browser-usable URL for images/files from the API.
 * Leaves data:, http(s):, and blob: unchanged; prefixes relative paths with backend origin.
 */
export function resolvePublicMediaUrl(url) {
  if (url == null || url === '') return '';
  const s = String(url).trim();
  if (!s) return '';
  if (/^(data:|https?:|blob:)/i.test(s)) return s;

  // Frontend public assets should NOT be prefixed with backend origin.
  // Example: `/images/logo.png` must stay on the website domain (not API domain).
  if (s.startsWith('/images/') || s === '/favicon.ico' || s === '/manifest.json' || s === '/robots.txt' || s === '/sitemap.xml') {
    return s;
  }

  const origin = getBackendOrigin();
  const path = s.startsWith('/') ? s : `/${s}`;
  return origin ? `${origin}${path}` : path;
}
